<div class="profile-container">
    <div class="">
        <div class="profile-content">
  
            <!-- <div class="personal-details">
                <h4 class="personal-details-title">Payment Term List</h4>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Term Name</th>
                      <th scope="col">Term Value</th>
                      <th scope="col">Term Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let term of paymentTermData | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: pageNumber+1,
                      totalItems: totalRecords
                    };let i = index">
                      <th scope="col">{{term.termName}}</th>
                      <th scope="col">{{term.termValue}}</th>
                      <th scope="col">{{term.termType}}</th>
                    </tr>    
                  </tbody>
                </table>
                <div class="pagination-block" *ngIf="paymentTermData.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                  </div>
            </div> -->
  
            <div class="personal-details">
          
              <div class="header-block">
                  <div class="header-title">
                      <p>Payment Term List</p>
                  </div>
                  <div class="add-block">
                    <div class="search">
                      <form autocomplete="off" >
                          <input [ngModelOptions]="{standalone: true}" placeholder="search user" [(ngModel)]="searchKey"/>
                      </form>
                      <i class="bi bi-x-lg" (click)="refreshSearch()" *ngIf="searchKey != ''"></i>
    
                      <i class="bi bi-search" (click)="getAllPaymentTermByWildSearch(0,10)"></i>
                    </div>
                      <button *ngIf="actionControls.isAdd" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> Add</button>
                  </div>
              </div>

              <table class="table table-striped">
                  <thead>
                      <tr>
                      <th style="width: 30%;">Term Name</th>
                      <th style="width: 25%;">Term Value</th>
                      <th style="width: 25%;">Term Type</th>
                      <th style="width: 20%;text-align: center;padding: 0;" class="">Action</th>
                      </tr>
                  </thead>
              </table>
              <div *ngIf="!isLoading">
                  <div class="data-view" *ngFor="let term of paymentTermData | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: pageNumber,
                      totalItems: totalRecords
                      }  ;let i = index">

                      <p style="width: 30%;">{{term.termName}}</p>
                      <p style="width: 25%;padding-left: 25px">{{term.termValue}}</p>
                      <p style="width: 25%;padding-left: 25px">{{term.termType}}</p>
                  
                      <p class="action-buttons" style="width: 20%;padding-left: 25px;">
                          <i *ngIf="actionControls.isModify" class="bi bi-pencil-square" (click)="getPaymentTermById(term.paymentTermId)" data-toggle="modal" data-target="#editModal" ></i>
                          <i *ngIf="actionControls.isDelete" class="bi bi-trash" (click)="getPaymentTermById(term.paymentTermId)" data-toggle="modal" data-target="#deleteModal"></i>
                      </p>
                  </div>
              </div>


              <div class="loader" *ngIf="isLoading">
                  <div class="spinner"></div>
              </div>

              <div class="loader"  *ngIf="!isLoading && paymentTermData.length == 0">
                  <div class="no-data">
                      <img src="assets/no-data-6.png" alt="">
                      <p>no data found</p>
                  </div>
                  
              </div>

              <div class="paginator">
                  <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                  [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}">
                  </p-paginator>
              </div>


          </div>
        </div>
    </div>
</div>


<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">Confirmation!!
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>are you sure? want to delete??</p>   
        <div class="modal-footer">
          <button type="button" id="closeModalButton1" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" (click)="deletePaymentTerm()" class="btn btn-primary">Delete</button>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Payment Term
          <span data-dismiss="modal">
            <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div [formGroup]="paymentTermForm" class="row">
          <div class="col-sm-12 col-md-6 col-lg-6">
              <div class="form-group">
                  <label>Term Name <span class="required">*</span></label>
                  <input class="form-control" formControlName="termName" type="text">
              </div>
          </div>

          <div class="col-sm-12 col-md-6 col-lg-6">
              <div class="form-group">
                  <label>Term Value <span class="required">*</span></label>
                  <input class="form-control" formControlName="termValue" type="text">
              </div>
          </div>

          <div class="col-sm-12 col-md-6 col-lg-6">
              <div class="form-group">
                  <label>Term Type <span class="required">*</span></label>
                  <select class="form-control" formControlName="termType">
                    <option *ngFor="let type of termTypes" [value]="type.value">
                      {{ type.viewValue }}
                    </option>
                  </select>
              </div>
          </div>

      </div>
          <div class="modal-footer">
              <button type="button" id="closeModalButton2" class="btn btn-secondary" data-dismiss="modal">Cancel</button>

              <button type="button" (click)="addPaymentTerm()" class="btn btn-primary">Add Payment Term</button>
          </div>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" id="editModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title" id="deleteModalLabel">Edit Payment Term
                  <span data-dismiss="modal">
                    <i class="bi bi-x-lg"></i>
                  </span>
              </h5>
          </div>
          <div class="modal-body">
            <div [formGroup]="paymentTermForm" class="row">
              <div class="col-sm-12 col-md-6 col-lg-6">
                  <div class="form-group">
                      <label>Term Name <span class="required">*</span></label>
                      <input class="form-control" formControlName="termName" type="text">
                  </div>
              </div>

              <div class="col-sm-12 col-md-6 col-lg-6">
                  <div class="form-group">
                      <label>Term Value <span class="required">*</span></label>
                      <input class="form-control" formControlName="termValue" type="text">
                  </div>
              </div>

              <div class="col-sm-12 col-md-6 col-lg-6">
                  <div class="form-group">
                      <label>Term Type <span class="required">*</span></label>
                      <select class="form-control" formControlName="termType">
                        <option *ngFor="let type of termTypes" [value]="type.value">
                          {{ type.viewValue }}
                        </option>
                      </select>
                  </div>
              </div>
            
          </div> 

              <div class="modal-footer">
                <button class="btn btn-secondary" id="closeModalButton3" data-dismiss="modal" (click)="closeEdit()">Cancel</button>

                <button type="button" (click)="editPaymentTerm()" class="btn btn-primary">Edit Payment Term</button>

              </div>
          </div>
      </div>
  </div>
</div>